import { stepperEnum } from "../../common/enum/bulkExportEnum";
import { RequestsCache } from "../Data/BulkData/RequestsCache";
import { PaginationControl } from "../PaginationControl";
import { Section } from "./Section";

export abstract class BulkSection extends Section {

 abstract request: string;
 abstract criteriaModel: any;
 abstract initialModel: any;
 abstract placeholderRequest: any;

 selectedStep: number = 0;
 selectedItem: any = undefined;

 cachedRequests: RequestsCache = {
    data: null,
    filterText: null,
    sortProperty: undefined,
    sortOrder: undefined,
    paginationControl: new PaginationControl(),
    hasNextPage: false
  };
    
  //True - Is selected first step in the stepper; otherwise False
  public isStepperFirstStep(): boolean {
    return this.selectedStep === stepperEnum.firstStep;
  }
  
  //True - Is selected second step in the stepper; otherwise False
  public isStepperSecondStep(): boolean {
    return this.selectedStep === stepperEnum.secondStep;
  }

  //True - Is selected second step in the stepper; otherwise False
  public isStepperThirdStep(): boolean {
    return this.selectedStep === stepperEnum.thirdStep;
  }

  // clear cache with the records and the filter text for Bulk Export requests lookup
  public clearRequestsCache(): void {
    this.cachedRequests = {
      data: null,
      filterText: null,
      sortProperty: undefined,
      sortOrder: undefined,
      paginationControl: new PaginationControl(),
      hasNextPage: false
    };
  }

  // clear cached sortProperty and sortOrder
  public clearRequestsSortCache(): void {
    this.cachedRequests.sortProperty = undefined;
    this.cachedRequests.sortOrder = undefined;
  }

  override resetSection(): void {
    this.criteriaModel = structuredClone(this.initialModel);
    this.selectedStep = 0;
    this.selectedItem = undefined;
    this.clearRequestsCache();
  }

}